import React from 'react'
import constant from '../../../constant'

const List = ({ stats }) => {

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" style={{ width: 70 }}>
                                            #
                                        </th>
                                        <th scope="col">Site Management Forms / Reports</th>
                                        <th scope="col">Statistics</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 011b
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Site Audit Index
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.siteAuditIndexCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingSiteAuditIndex.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                {/* <li className="list-inline-item px-2">
                                                    <a
                                                       href={'javascript:void(0);'}  title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li> */}

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 011a
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    Site Query Report Index{" "}
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.siteQueryReportIndexCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingSiteQueryReportIndex.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingSiteQueryReportIndex.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SMR 001a
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Site Query Form
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.siteQueryCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingSiteQueryForm.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingSiteQueryForm.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 011c
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    (P) VO Index Register

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.pvoIndexCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitPotentialVariationOrderIndexRegister.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                {/* <li className="list-inline-item px-2">
                                                    <a
                                                         href={'javascript:void(0);'}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li> */}

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    (Potential) Variation Order Form

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.pvoFormCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingPotentialVariationOrderForm.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingPotentialVariationOrderForm.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-013
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Drawing List

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.monthlyReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitDrawingList.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedDrawingList.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-014
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    List of Reference Book and Publication

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.monthlyReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitListOfReferenceBooksAndPublication.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedListOfReferenceBooksAndPublication.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 018
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Customer Property Inventory

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.customerPropertyInventoryCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingCustomerPropertyInventoryForm.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingCustomerPropertyInventoryForm.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            CVCD-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Shipyrd Evaluation of Shipyard Performance

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.shipyardPerformanceEvaluationCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitShipyardEvaluationPerformance.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={'javascript:void(0);'}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-022
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Owner NCR

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.monthlyReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitOwnerNCR.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedOwnerNCR.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-019
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    FAT Report

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.fatReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitFatReport.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedFatReport.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-020
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Bi-weekly Report

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.biWeeklyReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitBiWeeklyReport.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedBiWeeklyReport.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM-021
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Monthly Report

                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.monthlyReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitMonthlyReport.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedMonthlyReport.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default List
